import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

const breakPoint = 1024;

mm.add(
  {
    isDesktop: `(min-width: ${breakPoint}px) and (prefers-reduced-motion: no-preference)`,
    isMobile: `(max-width: ${
      breakPoint - 1
    }px) and (prefers-reduced-motion: no-preference)`,
  },
  (context) => {
    const { isMobile, isDesktop } = context.conditions;
    const items = gsap.utils.toArray(".agenda-hp__event");

    if (isMobile) {
      items.forEach((item) => {
        gsap.from(item, {
          y: 50,
          opacity: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: item,
            start: "top 80%",
            toggleActions: "play none none none"
          },
        });
      });
    }

    if (isDesktop) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".agenda-hp__events",
          start: "top-=200 75%",
          end: "bottom top-=100",
          scrub: true,
        },
      });

      tl.from(items, {
        y: 50,
        opacity: 0,
        stagger: 0.2,
        duration: 0.6,
        ease: "power2.out",
      }).to(
        items,
        {
          yPercent: (i) => -(i + 1) * 50,
          opacity: 0,
          ease: "none",
          stagger: 0.2,
          duration: 1,
        },
        "+=0.3"
      ); // petit délai après le fadeIn
    }
  }
);
